import { ISODate } from '@frk/eds-components';

// TODO rename as LiteratureDataDTO as this describes data from external api
export interface LiteratureData {
  hasFundLiteratures?: string | null;
  hasFundDocuments?: string | null;
  document?: (LiteratureDocumentData | null)[] | null;
}

// TODO: there may be more types to add in future
export enum LiteratureDocType {
  ANNUAL_REPORT = 'ANNUAL-REPORT',
  ARTICLES_OF_INCORPORATION = 'ARTICLES-OF-INCORPORATION',
  ATTRIBUTION = 'ATTRIBUTION',
  BROCHURE = 'BROCHURE',
  CAPITAL_GAINS_INDICATIONS = 'CAPITAL-GAINS-INDICATIONS',
  DISCLOSURE = 'DISCLOSURE',
  DISTRIBUTION_REPORT = 'DISTRIBUTION-REPORT',
  DIVIDEND_NOTICE = 'DIVIDEND-NOTICE',
  EDUCATIONAL_MATERIAL = 'EDUCATIONAL-MATERIAL',
  FACT_SHEET = 'FACT-SHEET',
  FISCAL_Q1_HOLDINGS = 'FISCAL-Q1-HOLDINGS',
  FISCAL_Q3_HOLDINGS = 'FISCAL-Q3-HOLDINGS',
  FLYER = 'FLYER',
  FORMS_AND_APPLICATIONS = 'FORMS-AND-APPLICATIONS',
  FUND_COMMENTARY = 'FUND-COMMENTARY',
  GENERAL_REPORT = 'GENERAL-REPORT',
  INVESTOR_GUIDE = 'INVESTOR-GUIDE',
  INVITATION = 'INVITATION',
  KIID = 'KIID',
  LETTER = 'LETTER',
  MARKET_PERSPECTIVE = 'MARKET-PERSPECTIVE',
  NOTICES = 'NOTICES',
  PERFORMANCE_FLYER = 'PERFORMANCE-FLYER',
  POLICY_AND_PROCEDURES = 'POLICY-AND-PROCEDURES',
  PORTFOLIO_HOLDINGS = 'PORTFOLIO-HOLDINGS',
  POSTCARD = 'POSTCARD',
  PRESENTATION = 'PRESENTATION',
  PRODUCT_PITCHBOOK = 'PRODUCT-PITCHBOOK',
  PRODUCT_PROFILE = 'PRODUCT-PROFILE',
  PROSPECTUS = 'PROSPECTUS',
  PROSPECTUS_STICKER = 'PROSPECTUS-STICKER',
  SALES_TOOLS = 'SALES-TOOLS',
  SEMI_ANNUAL_REPORT = 'SEMI-ANNUAL-REPORT',
  SHAREHOLDER_NOTICE = 'SHAREHOLDER-NOTICE',
  SNAPSHOT = 'SNAPSHOT',
  STATEMENT_OF_ADDITIONAL_INFORMATION = 'STATEMENT-OF-ADDITIONAL-INFORMATION',
  SUMMARY_PROSPECTUS = 'SUMMARY-PROSPECTUS',
  TRADE_RATIONALE = 'TRADE-RATIONALE',
  WHITEPAPER = 'WHITEPAPER',
}

// TODO rename as LiteratureDocumentDataDTO as this describes data from external api
export interface LiteratureDocumentData {
  id?: string | null;
  href?: string | null;
  cmsSearchTitle?: string | null;
  documentId?: string | null;
  dctermsTitle?: string | null;
  dctermsDescription?: string | null;
  dctermsAudience?: string[] | null;
  dctermsType?: LiteratureDocType | null;
  frkFundGroupCode?: string | null;
  // comma separated list of ShareClassCode ids eg "A, R, C, I, IS"
  frkShareClassCode?: string | null;
  frkShareClassFeeStructure?: string | null;
  // comma separated list of FundIds
  frkOneTISNumber?: string | null;
  literatureCode?: string | null;
  shareClassCode?: string | null;
  fundName?: string | null;
  shareClassName?: string | null;
  fileExtension?: string | null;
  fileSize?: string | null;
  publicationDate?: ISODate | null; // format "YYYY-MM-DD"
  nextUpdateDate?: string | null; // format "MM/YY"
  thumbnailPath?: string | null;
  description?: string | null;
  downloadUrl?: string | null;
  isClientUse?: string | null;
  assetType?: string | null;
  dctermsLanguage?: string[] | null;
  dctermsAvailable?: string | null;
  dctermsValid?: string | null;
  isActive?: string | null;
  packageCode?: string | null;
  exemptedUserTypes?: string | null;
  contentPath?: string | null;
  literatureHref?: string | null;
  frkReferenceDate?: string | null;
  cmsExternalLink?: string | null;
  topic?: string | null;
  subTopic?: string | null;
  isSiteIntl?: boolean;
  finraLink?: string;
  assetCategory?: string;
  orderLimit?: number;
  isOrdItself?: string;
  isInvestor?: boolean;
  exemptCustomers?: string;
  mandatoryMaterial?: string[];
  complementaryMaterial?: string[];
  isInv?: string;
  keywords?: string[];
  litDealerUse?: boolean;
  orderDate?: string;
  blueSkyStates?: string[];
  q1ph?: string;
  q3ph?: string;
  restrictedDealer?: string[];
  litPathPrevious?: string;
  customFilePath?: string;
  moreLink?: string;
  isDealerUse?: string;
  languageFilterValues?: string;
  pdfNumberingAppID?: string | null;
  printOnly?: string;
  isHistoryData?: boolean;
  dcsourceSystem?: string;
  externalId?: string;
  availableForLoggedInUser?: string;
  docId?: string;
  suppressIndexing?: string;
  fileUploadDate?: string;
  approvedFirm?: string[];
}

export interface LiteratureHistoryData {
  litHistDetail?: (LiteratureDocumentData | null)[] | null;
}
